import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import appActions from '@redux/app';
import utils from '@utils';
import {
	ApplicationService,
	SignupService,
	OrganizationService,
	UserService,
} from '@services';
import MaskedInput from 'react-text-mask';
import { Link } from 'react-router-dom';
import StockOfficers from '../../images/Stock_Officers.png';
import GreenCheck from '../../images/new_checkmark.png';

import './ClientSignUp.scss';

class ClientSignUp extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loggedIn            : !!localStorage.getItem('t'),
			token               : '',
			orgName             : '',
			orgLogo             : '',
			firstName           : '',
			lastName            : '',
			email               : '',
			password            : '',
			confirmPassword     : '',
			businessName        : '',
			phoneNumber         : '',
			address             : '',
			city                : '',
			state               : '',
			zipCode             : '',
			step                : 1,
			showAgencyInfo      : false,
			showPassword        : false,
			showConfirmPassword : false,
			loading             : false,
			signUpToken         : false,
			step1Errors         : {
				firstName     		: false,
				lastName      		: false,
				email         		: false,
				password      		: false,
				confirmPassword : false,
			},
			step2Errors : {
				businessName : false,
				phoneNumber  : false,
				address      : false,
				city         : false,
				state        : false,
				zipCode      : false,
			},
			usStates : [],
		};
		this.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
		this.rkLogo = '/images/rk-logo-alt.svg';
	}

	componentDidMount = () => {
		const { history } = this.props;
		const { loggedIn } = this.state;
		// redirect to the overview page if a user is already logged in
		if (loggedIn) {
			history.replace('/overview');
			return;
		}
		// get organization info based on token
		const token = new URLSearchParams(window.location.search).get('token');
		// get the list of us states
		ApplicationService.getUSStates()
			.then(({ data }) => {
				const usStates = data.map(({ Id, Name, Abbreviation }) => ({
					value : Id,
					label : `${Abbreviation} - ${Name}`,
				}));
				this.setState({ usStates });
			})
			.catch(() => {
				utils.notify({
					type    : 'error',
					message : 'Error loading US States',
					timeOut : 1500,
				});
			});

		// if no token is present default to rk logo
		if (!token) {
			this.setState({ showAgencyInfo : true, orgLogo : this.rkLogo });
			return;
		}
		OrganizationService.getDetailsForToken({ organizationToken : token })
			.then(({ data }) => {
				if (data) {
					this.setState({
						token          : token || undefined,
						orgName        : data.Name || '',
						orgLogo        : data.OrganizationLogoUrl || this.rkLogo,
						showAgencyInfo : true,
					});
				} else {
					OrganizationService.getDetailsForToken({ clientSignupToken : token })
						.then(({ data : tokenData }) => {
							this.setState({
								token          : token || undefined,
								orgName        : tokenData.Name || '',
								orgLogo        : tokenData.OrganizationLogoUrl || this.rkLogo,
								showAgencyInfo : true,
							});
						})
						.catch(() => { this.setState({ showAgencyInfo : true, orgLogo : this.rkLogo }); });
					// If the token is a signup token, call the verify token service to get client details
					UserService.verifyClientSignupToken(token)
						.then(({ data : clientData }) => {
							this.setState({
								firstName   : clientData.FirstName || '',
								lastName    : clientData.LastName || '',
								email       : clientData.EmailAddress || '',
								phoneNumber : clientData.MobilePhone ? utils.formatPhoneNumber(clientData.MobilePhone) : '',
								address     : clientData.StreetAddress1 || '',
								city        : clientData.City || '',
								state       : clientData.StateId || '',
								zipCode     : clientData.Zipcode || '',
								signUpToken : true,
							});
						}).catch(() => {
							history.push('/');
						});
				}
			})
			.catch(() => { this.setState({ showAgencyInfo : true, orgLogo : this.rkLogo }); });
	}

	/* Service Methods */
	createAccount = () => {
		const { login, receiveUser, history } = this.props;
		const {
			firstName,
			lastName,
			email,
			password,
			confirmPassword,
			businessName,
			phoneNumber,
			address,
			city,
			state,
			zipCode,
			token,
			signUpToken,
		} = this.state;

		const params = {
			FirstName       : firstName,
			LastName        : lastName,
			Email           : email,
			Password        : password,
			ConfirmPassword : confirmPassword,
			MobilePhone     : phoneNumber,
			StreetAddress1  : address,
			City            : city,
			StateId         : state,
			Zipcode         : zipCode,
			CompanyName     : businessName,
		};

		if (signUpToken) params.ClientSignUpToken = token;
		else params.OrganizationToken = token;

		this.setState({ loading : true });

		SignupService.clientSignup(params)
			.then((res) => UserService.login({ email, password })
				.then(({ data }) => {
					login();
					receiveUser(data);
					return res;
				}).catch((error) => error))
			.then(({ data }) => {
				SignupService.attachAddress(data.SignUpToken, {
					StreetAddress : 'n/a',
					City          : city,
					StateId       : state,
					Zip           : zipCode,
				});
				this.setState({ step : 3 });
			})
			.catch(({ response : { data } }) => {
				this.setState({ loading : false });
				// check if email is already in use
				if (data.find((e) => e.ErrorCode === 22 || e.ErrorCode === 26)) {
					const clientExists = data.find((e) => e.ErrorCode === 22);
					utils.notify({
						type    : clientExists ? 'info' : 'error',
						title   : 'An account with this email exists',
						message : clientExists ? 'You will be redirected to the login page.' : 'Please use a different email address.',
						timeOut : clientExists ? 1500 : 2500,
					});
					if (clientExists) {
						const timer = setTimeout(() => {
							clearTimeout(timer);
							history.push({
								pathname : '/login',
								search   : `?&user=${encodeURIComponent(email)}`,
							});
						}, 2000);
					} else {
						// If the email already exists, navigate the user back to Step 1
						// Then highlight the email field in red to emphasize that an error exists
						this.goBack();
						this.setState((prevState) => ({ step1Errors : { ...prevState.step1Errors, email : true } }));
					}
				} else {
					utils.notify({
						type    : 'error',
						message : 'An error occurred. Please try again.',
						timeOut : 1500,
					});
				}
			});
	};
	/* Service Methods */

	// handle changes to each input and update state
	handleInputChange = ({ target : { value, name } }) => {
		if (name === 'zipCode' && value.replace(/[0-9]/gi, '').length > 0) return;
		this.setState({ [name] : value }, () => {
			const { step } = this.state;
			if (step === 2) this.validateForm();
		});
	}

	// validates each input at the appropriate step
	validateForm = () => {
		const {
			firstName,
			lastName,
			email,
			password,
			confirmPassword,
			businessName,
			phoneNumber,
			address,
			city,
			state,
			zipCode,
			step1Errors,
			step2Errors,
			step,
		} = this.state;

		let isValid = true;

		if (step === 1) {
			step1Errors.firstName = firstName.trim() === '';
			step1Errors.lastName = lastName.trim() === '';
			step1Errors.email = !(/^\S+@\S+\.\S{2,}$/).test(email);
			step1Errors.password = password.trim().length < 7;
			step1Errors.confirmPassword = confirmPassword.trim().length < 7 || password.trim() !== confirmPassword.trim();
			this.setState({ step1Errors });
			isValid = (Object.values(step1Errors).filter((error) => error === true).length === 0);
		} else if (step === 2) {
			step2Errors.businessName = businessName.trim() === '';
			step2Errors.phoneNumber = utils.getDigits(phoneNumber).length < 10;
			step2Errors.address = address.trim() === '';
			step2Errors.city = city.trim() === '';
			step2Errors.state = state === '';
			step2Errors.zipCode = !(/^\d{5}$/).test(zipCode);
			this.setState({ step2Errors });
			isValid = (Object.values(step2Errors).filter((error) => error === true).length === 0);
		}
		return isValid;
	}

	// depending on the current step, validate inputs and either navigate to the next step or create the account
	onSubmit = (e) => {
		e.preventDefault();
		const { step } = this.state;
		if (step === 1 && this.validateForm()) this.setState({ step : 2 });
		else if (step === 2 && this.validateForm()) this.createAccount();
	}

	toggleShowPassword = (id) => this.setState((prevState) => ({ [id] : !prevState[id] }));

	goBack = () => this.setState((prevState) => ({ step : prevState.step - 1 }));

	render() {
		const {
			token,
			orgName,
			orgLogo,
			firstName,
			lastName,
			email,
			password,
			confirmPassword,
			businessName,
			phoneNumber,
			address,
			city,
			state,
			zipCode,
			step1Errors,
			step2Errors,
			step,
			showPassword,
			showConfirmPassword,
			usStates,
			loading,
			showAgencyInfo,
			signUpToken,
		} = this.state;

		return (
			<div id="client-signup">

				{/* Nav */}
				<nav className="navbar navbar-light bg-light">
					<div className="navbar-brand">
						<img src={orgLogo} alt="organization logo" className={showAgencyInfo ? '' : 'hidden'} />
						<If condition={showAgencyInfo}>
							{orgName}
						</If>
					</div>
				</nav>
				<div className={`progress${step === 2 || step === 3 ? ' progress-bg' : ''}`}>
					<div
						role="progressbar"
						className={`progress-bar step${step}`}
						aria-valuenow={((step / 3) * 100).toFixed(2)}
						aria-valuemin="0"
						aria-valuemax="100"
					>
						<span className="sr-only">{`${((step / 3) * 100).toFixed(2)}% Complete`}</span>
					</div>
				</div>
				{/* Nav */}

				<div className="container">
					<div className="row">
						<If condition={step === 1 || step === 2}>
							<div className="hidden-xs col-sm-6 col-lg-5 col-lg-offset-1">
								<button
									type="button"
									className={`goback btn ${step === 2 ? 'btn-link' : 'hidden'}`}
									disabled={loading}
									onClick={this.goBack}
								>
									<i className="rkf rkf-arrow-left" />
									&nbsp;
									Back
								</button>
								<br />
								<img className="img-responsive main-image" src={StockOfficers} alt="main" />
							</div>
						</If>

						{/* Create Account Form */}
						<div className="col-sm-6 col-lg-5">
							<Choose>
								<When condition={step === 1}>
									<div className="row form-group"><h3 className="col-sm-12"><strong>Create your free account</strong></h3></div>
									<form onSubmit={this.onSubmit}>
										<div className="row">
											<div className={`col-sm-6 form-group ${step1Errors.firstName ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="firstName"><strong>First Name</strong></label>
												<input
													type="text"
													className="form-control"
													name="firstName"
													id="firstName"
													placeholder="First Name"
													value={firstName}
													onChange={this.handleInputChange}
												/>
											</div>
											<div className={`col-sm-6 form-group ${step1Errors.lastName ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="lastName"><strong>Last Name</strong></label>
												<input
													type="text"
													className="form-control"
													id="lastName"
													name="lastName"
													placeholder="Last Name"
													value={lastName}
													onChange={this.handleInputChange}
												/>
											</div>
										</div>
										<div className="row">
											<div className={`col-sm-12 form-group ${step1Errors.email ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="email">
													<strong>Email</strong>
													&nbsp;
													<span className="email-disclaimer">(This will be your username.)</span>
												</label>
												<input
													type="email"
													className="form-control"
													id="email"
													name="email"
													placeholder="Email"
													value={email}
													onChange={this.handleInputChange}
													disabled={signUpToken}
												/>
											</div>
										</div>
										<div className="row">
											<div className={`col-sm-12 form-group ${step1Errors.password ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="password"><strong>Password</strong></label>
												<input
													autoComplete="on"
													type={showPassword ? 'text' : 'password'}
													className="form-control"
													id="password"
													name="password"
													placeholder="At least 7 characters"
													value={password}
													onChange={this.handleInputChange}
												/>
												<button
													tabIndex="-1"
													aria-label="Show Password"
													title="Show Password"
													type="button"
													id="showPassword"
													className={`btn btn-link rkf ${showPassword ? 'rkf-eye-hidden' : 'rkf-eye'}`}
													onClick={({ target : { id } }) => this.toggleShowPassword(id)}
												/>
											</div>
										</div>
										<div className="row">
											<div className={`col-sm-12 form-group ${step1Errors.confirmPassword ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="confirmPassword"><strong>Confirm Password</strong></label>
												<input
													autoComplete="on"
													type={showConfirmPassword ? 'text' : 'password'}
													className="form-control"
													id="confirmPassword"
													name="confirmPassword"
													placeholder="At least 7 characters"
													value={confirmPassword}
													onChange={this.handleInputChange}
												/>
												<button
													tabIndex="-1"
													aria-label="Show Confirm Password"
													title="Show Confirm Password"
													type="button"
													id="showConfirmPassword"
													className={`btn btn-link rkf ${showConfirmPassword ? 'rkf-eye-hidden' : 'rkf-eye'}`}
													onClick={({ target : { id } }) => this.toggleShowPassword(id)}
												/>
												<p className={`small has-error ${step1Errors.confirmPassword && password !== confirmPassword ? '' : 'hidden'}`}>
													<em>Password must match</em>
												</p>
												<p className={`small has-error ${step1Errors.confirmPassword && password.length < 7 ? '' : 'hidden'}`}>
													<em>Must be at least 7 characters</em>
												</p>
											</div>
										</div>
										<div className="row">
											<div className="col-sm-12 form-group">
												<button type="submit" className="btn btn-primary btn-block action-button">
													Create account
												</button>
											</div>
										</div>
										<div className="row">
											<div className="col-sm-12 form-group disclaimer-text">
												By signing up, you agree to the&nbsp;
												<a href="https://www.rollkall.com/terms" target="_blank" rel="noopener noreferrer">
													Terms of Use
												</a>
												&nbsp;and&nbsp;
												<a href="https://www.rollkall.com/privacy" target="_blank" rel="noopener noreferrer">
													Privacy Policy
												</a>
												.
											</div>
										</div>
									</form>
								</When>
								<When condition={step === 2}>
									<div className="row form-group"><h3 className="col-sm-12"><strong>Enter your account information</strong></h3></div>
									<form onSubmit={this.onSubmit}>
										<div className="row">
											<div className={`col-sm-12 form-group ${step2Errors.businessName ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="businessName"><strong>Business Name</strong></label>
												<input
													type="text"
													className="form-control"
													id="businessName"
													name="businessName"
													placeholder="Business Name"
													value={businessName}
													onChange={this.handleInputChange}
												/>
											</div>
										</div>
										<div className="row">
											<div className={`col-sm-12 form-group ${step2Errors.phoneNumber ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="phoneNumber"><strong>Phone Number</strong></label>
												<MaskedInput
													type="tel"
													className="form-control"
													name="phoneNumber"
													id="phoneNumber"
													placeholder="(000) 000-0000"
													value={phoneNumber}
													mask={this.phoneMask}
													onChange={this.handleInputChange}
												/>
											</div>
										</div>
										<div className="row">
											<div className={`col-sm-12 form-group ${step2Errors.address ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="address"><strong>Address</strong></label>
												<input
													type="tel"
													className="form-control"
													id="address"
													name="address"
													placeholder="123 Main St"
													value={address}
													onChange={this.handleInputChange}
												/>
											</div>
										</div>
										<div className="row">
											<div className={`col-sm-12 form-group ${step2Errors.city ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="city"><strong>City</strong></label>
												<input
													type="text"
													className="form-control"
													id="city"
													name="city"
													placeholder="City"
													value={city}
													onChange={this.handleInputChange}
												/>
											</div>
										</div>
										<div className="row">
											<div className={`col-sm-6 form-group ${step2Errors.state ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="state"><strong>State</strong></label>
												<select
													className="form-control"
													name="state"
													id="state"
													value={state}
													onChange={this.handleInputChange}
												>
													<option value="" disabled>State</option>
													<For each="item" of={usStates}>
														<option value={item.value} key={`state-option-${item.value}`}>
															{item.label}
														</option>
													</For>
												</select>
											</div>
											<div className={`col-sm-6 form-group ${step2Errors.zipCode ? 'has-error' : ''}`}>
												<label className="form-label" htmlFor="zipCode"><strong>Zip Code</strong></label>
												<input
													type="tel"
													className="form-control"
													id="zipCode"
													name="zipCode"
													value={zipCode}
													maxLength={5}
													onChange={this.handleInputChange}
												/>
											</div>
										</div>
										<div className="row">
											<div className="col-sm-12 form-group">
												<If condition={phoneNumber !== '' && utils.getDigits(phoneNumber).length === 10
													&& address !== ''
													&& city !== ''
													&& state !== ''
													&& zipCode !== '' && zipCode.trim().length === 5}
												>
													<button type="submit" className="btn btn-primary btn-block action-button">
														{loading ? 'Please Wait...' : 'Next'}
													</button>
												</If>
											</div>
										</div>
										<div className="row">
											<div className={`col-sm-12 form-group ${step === 2 ? 'visible-xs-block' : 'hidden'}`}>
												<button
													type="button"
													className="btn btn-default btn-block"
													onClick={this.goBack}
													disabled={loading}
												>
													Back
												</button>
											</div>
										</div>
									</form>
								</When>
							</Choose>
						</div>
						{/* Create Account Form */}

						<div className="col-sm-12">
							<If condition={step === 3}>
								<div className="row">
									<img className="img-responsive center-image" src={GreenCheck} alt="checkmark" />
								</div>
								<div className="row form-group text-center"><h1 className="col-sm-12"><strong>Account Created</strong></h1></div>
								<div className="row text-center">
									<div className="col-sm-12">
										Thank you for creating your account. You now have access to your business&nbsp;
										<br className="hidden-xs" />
										portal to view, request, and pay your jobs.
									</div>
									<div className="col-sm-12">
										<br />
										<Link to="/overview">View Your Business Portal</Link>
									</div>
								</div>
							</If>
						</div>

					</div>
				</div>
				{/* Powered by RollKall */}
				<div className="col-sm-12 powered-by">
					<If condition={token}>
						<a href="https://www.rollkall.com" target="_blank" rel="noopener noreferrer">
							Powered By
							<img className="img-responsive" src={this.rkLogo} alt="rollkall logo" />
						</a>
					</If>
				</div>
				{/* Powered by RollKall */}
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	login       : bindActionCreators(appActions, dispatch).login,
	receiveUser : bindActionCreators(appActions, dispatch).receiveUser,
});

ClientSignUp.propTypes = {
	history     : PropTypes.object,
	login       : PropTypes.func.isRequired,
	receiveUser : PropTypes.func.isRequired,
};

ClientSignUp.defaultProps = {
	history : {},
};

export default connect(null, mapDispatchToProps)(ClientSignUp);
